import React from 'react';
import '../styles/ErrorPage.css';

const ServerError: React.FC = () => {
  return (
    <div className="error-page">
      <h1>500 - Server Error</h1>
      <p>Something went wrong on our end. Please try again later.</p>
      <a href="/">Return to Home</a>
    </div>
  );
};

export default ServerError;